import { createDomainApi } from '@skylabs-digital/react-proto-kit';
import { optOutInputSchema, optOutSchema } from '../schemas/optout.schema';

export type { OptOut, OptOutInput } from '../schemas/optout.schema';

export const optOutsApi = createDomainApi('opt-outs/:userId', optOutSchema, optOutInputSchema);
